function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
/**
 * Twitter/X OAuth 2.0 + PKCE. Authenticates X credentials.
 * Does not touch Faucet records, payments, or peer notify.
 *
 * Uses node-fetch (HTTP/1.1) rather than Node's global undici fetch.
 * A hung or HTTP/2 failure against api.x.com must abort this attempt,
 * not take down the Saito process.
 */

var crypto = require('crypto');
var TWITTER_TOKEN_URL = 'https://api.x.com/2/oauth2/token';
var TWITTER_USER_URL = 'https://api.x.com/2/users/me';
var TWITTER_FETCH_TIMEOUT_MS = 20000;
function authError(code, httpStatus, title, message) {
  var extra = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  var err = new Error(message);
  err.code = code;
  err.httpStatus = httpStatus;
  err.title = title;
  err.popupMessage = message;
  Object.assign(err, extra);
  return err;
}
function isAccountValid(createdAt) {
  var now = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Date.now();
  // Same anti-abuse bar as GitHub: account must be at least six months old.
  var created = createdAt instanceof Date ? createdAt : new Date(createdAt);
  if (Number.isNaN(created.getTime())) {
    return false;
  }
  var eligibleAt = new Date(created.getTime());
  eligibleAt.setMonth(eligibleAt.getMonth() + 6);
  return now >= eligibleAt.getTime();
}
function base64Url(buf) {
  return Buffer.from(buf).toString('base64').replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/g, '');
}
function createPkce() {
  var code_verifier = base64Url(crypto.randomBytes(32));
  var code_challenge = base64Url(crypto.createHash('sha256').update(code_verifier).digest());
  return {
    code_verifier: code_verifier,
    code_challenge: code_challenge
  };
}
function twitterFetch(url) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  // Server-only. Faucet is webpack-bundled for the browser; a static
  // node-fetch/https require would load Node http agents into saito.js.
  var fetch = require(/* webpackIgnore: true */'node-fetch');
  return fetch(url, _objectSpread(_objectSpread({
    timeout: TWITTER_FETCH_TIMEOUT_MS
  }, options), {}, {
    headers: _objectSpread({
      Accept: 'application/json',
      'User-Agent': 'Saito-Faucet-OAuth'
    }, options.headers || {})
  }));
}
function mapTwitterFetchError(err, fallbackCode, title) {
  if ((err === null || err === void 0 ? void 0 : err.code) === fallbackCode || err !== null && err !== void 0 && err.httpStatus) {
    return err;
  }
  var aborted = (err === null || err === void 0 ? void 0 : err.name) === 'AbortError' || (err === null || err === void 0 ? void 0 : err.type) === 'aborted' || (err === null || err === void 0 ? void 0 : err.type) === 'request-timeout' || /timeout/i.test(String((err === null || err === void 0 ? void 0 : err.message) || ''));
  return authError(fallbackCode, 502, title, aborted ? 'X authorization timed out. Close this window and try again.' : 'Could not complete X authorization. Close this window and try again.');
}
function exchangeTwitterCode(_x) {
  return _exchangeTwitterCode.apply(this, arguments);
}
function _exchangeTwitterCode() {
  _exchangeTwitterCode = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(_ref) {
    var clientId, clientSecret, code, redirectUri, code_verifier, body, res, data, msg, _t;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.p = _context.n) {
        case 0:
          clientId = _ref.clientId, clientSecret = _ref.clientSecret, code = _ref.code, redirectUri = _ref.redirectUri, code_verifier = _ref.code_verifier;
          body = new URLSearchParams();
          body.set('grant_type', 'authorization_code');
          body.set('code', code);
          body.set('redirect_uri', redirectUri);
          body.set('code_verifier', code_verifier);
          body.set('client_id', clientId);
          _context.p = 1;
          _context.n = 2;
          return twitterFetch(TWITTER_TOKEN_URL, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
              Authorization: 'Basic ' + Buffer.from(clientId + ':' + clientSecret, 'utf8').toString('base64')
            },
            body: body.toString()
          });
        case 2:
          res = _context.v;
          _context.n = 4;
          break;
        case 3:
          _context.p = 3;
          _t = _context.v;
          throw mapTwitterFetchError(_t, 'twitter_token_exchange_failed', 'X verification failed');
        case 4:
          _context.n = 5;
          return res.json()["catch"](function () {
            return {};
          });
        case 5:
          data = _context.v;
          if (!(!res.ok || data.error || !data.access_token)) {
            _context.n = 6;
            break;
          }
          msg = data.error_description || data.error || "token_http_".concat(res.status);
          throw authError('twitter_token_exchange_failed', 502, 'X verification failed', String(msg));
        case 6:
          return _context.a(2, {
            access_token: data.access_token,
            token_type: data.token_type || 'bearer',
            scope: data.scope || ''
          });
      }
    }, _callee, null, [[1, 3]]);
  }));
  return _exchangeTwitterCode.apply(this, arguments);
}
function fetchTwitterUser(_x2) {
  return _fetchTwitterUser.apply(this, arguments);
}
/**
 * Authenticate Twitter/X credentials (authorization code + PKCE).
 * Returns a provider identity. Does not touch Faucet state.
 */
function _fetchTwitterUser() {
  _fetchTwitterUser = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(accessToken) {
    var url, res, data, user, msg, _t2;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.p = _context2.n) {
        case 0:
          url = new URL(TWITTER_USER_URL);
          url.searchParams.set('user.fields', 'created_at,name,username');
          _context2.p = 1;
          _context2.n = 2;
          return twitterFetch(url.toString(), {
            method: 'GET',
            headers: {
              Authorization: "Bearer ".concat(accessToken)
            }
          });
        case 2:
          res = _context2.v;
          _context2.n = 4;
          break;
        case 3:
          _context2.p = 3;
          _t2 = _context2.v;
          throw mapTwitterFetchError(_t2, 'twitter_user_fetch_failed', 'X verification failed');
        case 4:
          _context2.n = 5;
          return res.json()["catch"](function () {
            return {};
          });
        case 5:
          data = _context2.v;
          user = data.data || {};
          if (!(!res.ok || !user.id)) {
            _context2.n = 6;
            break;
          }
          msg = data.detail || data.title || data.message || "user_http_".concat(res.status);
          throw authError('twitter_user_fetch_failed', 502, 'X verification failed', String(msg));
        case 6:
          return _context2.a(2, {
            id: String(user.id),
            username: String(user.username || ''),
            name: String(user.name || ''),
            created_at: String(user.created_at || '')
          });
      }
    }, _callee2, null, [[1, 3]]);
  }));
  return _fetchTwitterUser.apply(this, arguments);
}
function authenticateCredentials(_x3) {
  return _authenticateCredentials.apply(this, arguments);
}
function _authenticateCredentials() {
  _authenticateCredentials = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(_ref2) {
    var code, clientId, clientSecret, redirectUri, code_verifier, token, user, provider_user_id;
    return _regenerator().w(function (_context3) {
      while (1) switch (_context3.n) {
        case 0:
          code = _ref2.code, clientId = _ref2.clientId, clientSecret = _ref2.clientSecret, redirectUri = _ref2.redirectUri, code_verifier = _ref2.code_verifier;
          _context3.n = 1;
          return exchangeTwitterCode({
            clientId: clientId,
            clientSecret: clientSecret,
            code: code,
            redirectUri: redirectUri,
            code_verifier: code_verifier
          });
        case 1:
          token = _context3.v;
          console.log('[Faucet] OAuth twitter token exchange ok');
          _context3.n = 2;
          return fetchTwitterUser(token.access_token);
        case 2:
          user = _context3.v;
          token.access_token = '';
          console.log('[Faucet] OAuth twitter profile id=' + user.id + ' username=' + user.username + ' created_at=' + (user.created_at || '(none)'));
          if (!(!user.created_at || !isAccountValid(user.created_at))) {
            _context3.n = 3;
            break;
          }
          throw authError('twitter_account_too_new', 403, 'X account not eligible', 'Registration requires an X account that is at least six months old.', {
            details: user.username ? "Account: ".concat(user.username) : '',
            username: user.username,
            created_at: user.created_at
          });
        case 3:
          provider_user_id = String(user.id || '').trim();
          if (provider_user_id) {
            _context3.n = 4;
            break;
          }
          throw authError('twitter_missing_user_id', 502, 'X verification failed', 'X profile did not include a stable user id.');
        case 4:
          return _context3.a(2, {
            provider: 'twitter',
            provider_user_id: provider_user_id,
            provider_username: String(user.username || ''),
            provider_display_name: String(user.name || user.username || ''),
            provider_account_created_at: Date.parse(user.created_at) || 0
          });
      }
    }, _callee3);
  }));
  return _authenticateCredentials.apply(this, arguments);
}
module.exports = {
  createPkce: createPkce,
  authenticateCredentials: authenticateCredentials
};